import React from "react";
import { Outlet } from "react-router-dom";
import TeacherSidebar from "../components/TeacherSidebar";
import Footer from "../components/Footer";

export default function TeacherLayout() {
  return (
    <div className="flex flex-col min-h-screen">
      <div className="flex flex-1">
        <TeacherSidebar />
        <main className="flex-1 p-6 bg-gray-100 overflow-auto">
          <Outlet />
        </main>
      </div>
     
    </div>
  );
}
